import FieldConfig from "../../../proto/field-config";
import FieldProgress from "../../../generic/progress/progress";
import Task from "../../../../model2/task/task";
import ItemModel from "../../../../model2/item/item-model";

export default class FieldTaskProgress extends FieldProgress {

    constructor(config:FieldConfig) {
        super(config)

        this.typeLabel  = "Progress"
        this.label      = "Progress"


        this.fieldParams.tableCellOnValueChange = this.tableCellOnValueChange
    }

    canEdit(model:Task):boolean {
        return model.acl.canChangeTaskProgress
    }

    // Custom Methods

    tableCellOnValueChange = async (item:ItemModel, value: number | null) => {

        item.task.progress = !_.isNull(value) ? value : null

        item.task.save()
    }

}
